<template>
  <div class="box">
    <img :src="list.img" />
    <div class="box-content" v-html="list.content"></div>
  </div>
</template>
<script>
export default {
  props: ["list"],
  data() {
    return {};
  }
};
</script>
<style scoped>
.box {
  border-radius: 32px;
  background-color: var(--white);
  color: var(--gray-700);
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 120px;
  padding: 20px 0;
}

.box {
  transition: transform 0.3s ease;
}
.box:hover {
  transform: translateY(-10px);
}
.box img {
  max-width: 60px;
  height: auto;
  margin-bottom: 16px;
}

.box-content {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  word-break: break-all;
  white-space: pre-wrap;
}

@media (min-width: 1024px) {
  .box {
    font-size: 20px;
    line-height: 28px;
    height: 156px;
    padding: 28px 0px;
  }

  .box img {
    max-width: 84px;
  }
}
</style>
